// TODO: Import React module
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import QRCode from 'react-qr-code';
import html2canvas from 'html2canvas';

// TODO: Import MUI module
import BoardBackground from './BoardBackground.png';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// TODO: Import custom component
import { FetchData } from '../../common/common.js';

// Import context

export default function BoxIntroBoard() {
    // TODO: Define useContext

    // TODO: Define variable
    const [info, setInfo] = React.useState([]);
    const [searchParams] = useSearchParams();
    const isAdmin = searchParams.get('admin') === 'true';

    const printArea = React.useRef();

    // TODO: Define event
    React.useEffect(() => {
        const formData = new FormData();
        formData.append('action', 'GetIntroBoard');
        formData.append('id', searchParams.get('id'));

        FetchData(
            'https://www.pohtyh.edu.hk/YiYuan/webservices.php',
            formData,
            ((result) => { setInfo(result); })
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlePrint = () => {
        const box = printArea.current;
        /*if (box) {
            const printWindow = window.open('', '', 'height=900,width=1300'); // 創建一個新窗口
            printWindow.document.write('<html><head><title>Print</title>'); // 在新窗口中創建HTML文檔
            printWindow.document.write(`
                <style>
                    @font-face {
                        font-family: 'JasonHandwriting1';
                        src: url('https://www.pohtyh.edu.hk/YiYuan/JasonHandwriting1.ttf') format('truetype');
                    }
                    * {
                        font-family: 'JasonHandwriting1';
                    }
                    @media print {
                        .IntroBoard {
                            background-image: url('https://www.pohtyh.edu.hk/YiYuan/images/BoardBackground.png');
                            backgroundSize: 'contain';
                            m: 2;
                            width: '1200px';
                            height: '800px';
                            -webkit-print-color-adjust: exact !important;
                        }
                    }
                        .IntroBoard {
                            background-image: url('https://www.pohtyh.edu.hk/YiYuan/images/BoardBackground.png');
                            backgroundSize: 'contain';
                            m: 2;
                            width: '1200px';
                            height: '800px';
                        }
                </style>
            `); // 在新窗口中創建HTML文檔
            printWindow.document.write('</head><body>'); // 在新窗口中創建HTML文檔
            printWindow.document.write(box.outerHTML); // 將Box元素的HTML代碼寫入HTML文檔中
            printWindow.document.write('</body></html>');
            printWindow.print(); // 在新窗口中打印
            //printWindow.close(); // 關閉新窗口
        }*/
        if (box) {
            html2canvas(box, { useCORS: true }).then(canvas => {
                const link = document.createElement('a');
                link.download = 'box.png';
                link.href = canvas.toDataURL();
                link.click();
            });
        }
    };

    // TODO Define function

    return (
        isAdmin &&
        <Box
            className="IntroBoard"
            sx={{
                backgroundImage: `url(${BoardBackground})`,
                backgroundSize: 'contain',
                m: 2,
                width: '1200px',
                height: '800px',
            }}
            onClick={handlePrint}
            ref={printArea}
        >
            <Typography sx={{
                fontFamily: 'JasonHandwriting1',
                fontSize: '10rem',
                fontWeight: 'bold',
                mt: 2,
                mx: 2,
                textAlign: 'center',
            }}>
                {info.Title}
            </Typography>
            <Typography sx={{
                fontFamily: 'JasonHandwriting1',
                fontSize: '3rem',
                fontWeight: 'bold',
                mx: 2,
                textAlign: 'center',
            }}>
                {info.Intro}
            </Typography>
            <Box sx={{ display: 'flex' }}>
                <Box sx={{ m: 2, width: '700px', height: '380px' }}>
                    <Box
                        component="img"
                        src={`https://www.pohtyh.edu.hk/YiYuan/images/plants/${searchParams.get('id')}/cover.jpg`}
                        sx={{ width: 1, height: 1, objectFit: 'cover' }}
                    />
                </Box>
                <Box sx={{ display: 'flex', flex: '1', flexDirection: 'column', justifyContent: 'center', m: 2, maxHeight: '380px', }}>
                    <QRCode
                        bgColor="transparent"
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={`https://www.pohtyh.edu.hk/YiYuan/Plant?id=${searchParams.get('id')}`}
                        viewBox={`0 0 256 256`}
                    />
                    <Typography sx={{
                        fontFamily: 'JasonHandwriting1',
                        fontSize: '3rem',
                        fontWeight: 'bold',
                        mx: 2,
                        textAlign: 'center',
                    }}>
                        Scan我知多D
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}